# Sekretesspolicy för Safe Learning Management System.

## 1\. Introduktion

Denna integritetspolicy förklarar hur Safe Asset Group International AB ("vi", "oss" eller "vår") samlar in, använder, delar och skyddar personlig information som erhållits från användare ("du" eller "din") av vår Safe Learning Management System. Vi är angelägna om att skydda din integritet och hantera dina uppgifter på ett öppet och transparent sätt.

## 2\. Informationsinsamling

Vi samlar in information som du tillhandahåller direkt till oss när du använder vår tjänst, eller förser oss med din kontaktinformation för att få tillgång till tjänstens administrativa portal.

De typer av data vi samlar in kan vara:

- Namn
- E-postadress
- Användningsdata
- Angivna koder
- Tidpunkt då en kurs startar
- Tidpunkt då en kurs är klar
- Tidpunkt för sista aktivitet för en session

Vi samlar bara in ditt namn och din e-postadress om du behöver tillgång till tjänstens administrativa portal.

## 3\. Användning av information

Vi använder den insamlade informationen för att tillhandahålla, underhålla och förbättra vår tjänst.

## 4\. Datalagring och säkerhet

På Safe Asset Group International AB tar vi säkerheten och skyddet av dina uppgifter på allvar. Vi implementerar och underhåller lämpliga tekniska och organisatoriska säkerhetsåtgärder för att skydda din personliga information från obehörig åtkomst, förstörelse, förlust, ändring eller missbruk.

### 4.1 Datalagring

- Vi lagrar dina uppgifter på säkra servrar i Europeiska unionen.
- Vi säkerhetskopierar regelbundet dina data för att förhindra dataförlust och hjälpa till med återställning.
- Vi behåller dina uppgifter så länge som ditt konto är aktivt eller vid behov för att tillhandahålla tjänster till dig. Vi kommer att radera dina uppgifter på begäran eller efter en längre period av inaktivitet, förutom där vi enligt lag är skyldiga att behålla dem.

### 4.2 Datasäkerhetsåtgärder

- All dataöverföring mellan dig och våra servrar är krypterad med SSL/TLS-protokoll.
- Vi använder brandväggar och multifaktorautentisering för att förhindra obehörig åtkomst till våra system.
- Vi genomför regelbundet säkerhetsrevisioner och sårbarhetsbedömningar för att identifiera och hantera potentiella säkerhetsrisker.
- Tillgång till dina personuppgifter av våra anställda är begränsad och beviljas på grundval av behov att veta. Alla anställda med sådan tillgång är bundna av strikta sekretessskyldigheter.

### 4.3 Tredjepartstjänsteleverantörer

- Vi använder tredjepartstjänsteleverantörer, inklusive vår serverleverantör, för att stödja vår verksamhet. Dessa leverantörer fungerar som databehandlare och behandlar endast uppgifter på våra instruktioner.
- Vår serverleverantör, The Constant Company, LLC, lagrar och behandlar dina uppgifter för vår räkning. De har inte rätt att använda dina personuppgifter utöver vad som är nödvändigt för att hjälpa oss.
- Vi har databehandlingsavtal på plats med alla våra databehandlare, inklusive vår serverleverantör. Dessa avtal kräver att de:
  - Behandla data endast enligt våra dokumenterade instruktioner
  - Genomför lämpliga tekniska och organisatoriska åtgärder för att skydda personuppgifter
  - Hjälp oss att uppfylla våra skyldigheter enligt dataskyddslagar
  - Radera eller returnera alla personuppgifter till oss efter avslutat tillhandahållande av tjänster
  - Underkasta sig revisioner och inspektioner och förse oss med all information vi behöver för att säkerställa att vi båda uppfyller våra artikel 28-skyldigheter (GDPR)
- När vi använder tredje parts tjänsteleverantörer avslöjar vi endast den personliga information som är nödvändig för att leverera tjänsten.
- Vi granskar regelbundet säkerhets- och integritetspraxis för våra databehandlare för att säkerställa att de uppfyller våra standarder och juridiska krav.

### 4.4 Förfaranden för dataintrång

I händelse av ett dataintrång som påverkar din personliga information kommer vi:

- Meddela dig via e-post omgående
- Ge information om omfattningen av överträdelsen
- Informera dig om de potentiella konsekvenserna
- Ge dig råd om de åtgärder vi vidtar för att reagera på och mildra intrånget

### 4.5 Din roll inom datasäkerhet

Medan vi implementerar dessa säkerhetsåtgärder är överföringen av information via internet inte helt säker. Vi ber att du också vidtar åtgärder för att hålla din data säker:

- Håll ditt system och dina applikationer uppdaterade

Om du har anledning att tro att din interaktion med oss ​​inte längre är säker (till exempel om du känner att säkerheten för ditt konto har äventyrats), vänligen meddela oss omedelbart.

## 5\. Tredjepartsdelning

Vi säljer inte dina personuppgifter. Vi kan komma att dela din information med juridiska myndigheter när det krävs enligt lag.

## 6\. Användarrättigheter

Du har rätt att:

- Få tillgång till dina personuppgifter
- Korrigera felaktiga uppgifter
- Begär radering av dina uppgifter
- Invända mot behandling av dina uppgifter

Observera att för användare som endast kommer åt kurser med distribuerade koder, samlas ingen direkt personligt identifierbar information in. Vi samlar inte heller in tillräckligt med annan information tillräckligt detaljerad för att peka ut en specifik individ. Därför kan vi inte behandla förfrågningar om rättigheter för de registrerade för dessa användare.

## 7\. Cookies och spårningstekniker

Vi använder inte spårningscookies för att tillhandahålla vår tjänst. Vår användning av cookies är begränsad till viktiga cookies som krävs för dem som kommer åt den administrativa portalen. Viktiga cookies ställs bara in när du loggar in på den administrativa portalen.

## 8\. Ändringar av integritetspolicyn

Vi kan komma att uppdatera denna integritetspolicy då och då. Vi kommer att meddela dig om eventuella ändringar genom att publicera den nya integritetspolicyn på denna sida.

## 9\. Kontaktinformation

Om du har några frågor om denna integritetspolicy, vänligen kontakta oss på:

[info@safeassetgroup.com](mailto:info@safeassetgroup.com)  
\+46 31 201 000

Safe Asset Group International AB  
Kivra: 559072-8746  
106 31 Stockholm  
Sverige

Senast uppdaterad: 2024-09-05
